var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDislike = function SvgDislike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.893 16.89a3.142 3.142 0 0 1-.224-.361l.758-3.835.236-1.194h-5.8a.672.672 0 0 1-.667-.666v-.9A.63.63 0 0 1 3.21 9.8l.043-.132.002-.005 2.182-5.042a.678.678 0 0 1 .55-.289h6.76c.524 0 .948.43.949.942v6.533c0 .132-.04.261-.114.372l-.085.105-4.604 4.605Zm8.47-5.39V4.334h.5v7.168h-.5Z",
    stroke: "#F44336",
    strokeWidth: 2
  })));
};

export default SvgDislike;